import { render, staticRenderFns } from "./gruppiNazionalita.vue?vue&type=template&id=d48177c8&"
import script from "./gruppiNazionalita.vue.ts?vue&type=script&lang=ts&"
export * from "./gruppiNazionalita.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports